import { createRouter, createWebHistory } from 'vue-router'
import { isAdmin, supabase } from '../lib/supabase'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/LoginView.vue'),
      meta: { public: true },
    },
    {
      path: '/set-password',
      name: 'set-password',
      component: () => import('../views/SetPasswordView.vue'),
      meta: { public: true },
    },
    {
      path: '/',
      component: () => import('../layouts/AdminLayout.vue'),
      children: [
        { path: '', name: 'dashboard', component: () => import('../views/DashboardView.vue') },
        { path: 'products', name: 'products', component: () => import('../views/ProductsView.vue') },
        { path: 'plans', name: 'plans', component: () => import('../views/PlansView.vue') },
        { path: 'licenses', name: 'licenses', component: () => import('../views/LicensesView.vue') },
      ],
    },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
})

router.beforeEach(async (to) => {
  const { data } = await supabase.auth.getSession()
  const session = data.session

  if (to.meta.public) {
    if (to.name === 'login' && session && isAdmin(session.user.app_metadata)) return '/'
    return true
  }

  if (!session) return { name: 'login', query: { redirect: to.fullPath } }
  if (!isAdmin(session.user.app_metadata)) {
    await supabase.auth.signOut()
    return { name: 'login', query: { reason: 'forbidden' } }
  }
  return true
})

export default router
